import React, { useEffect, useState, Fragment, useRef } from "react";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { WeighReportContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const headerLables = this.props.lables;
        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const details = this.props.weighDetails;
        const detailDeductions = this.props.detailDeductions;
        const totalSummaryRow = this.props.totalSummaryRow;
        const contentRowNames = this.props.rowNames;

        function roundNumbers(number) {
            return Math.round((number + Number.EPSILON) * 100) / 100
        }

        function generateTotalRow(mobileSessionID) {

            var result = totalSummaryRow.find(x => x.mobileSessionID === mobileSessionID);

            var tempRes = [];

            contentRowNames.forEach((x, i) => {
                if (i > 6) {
                    for (var prop in result) {
                        if (prop === x) {
                            tempRes.push({ name: prop, value: result[prop] });
                        }
                    }
                }
            });

            if (result) {
                return (
                    <tr>
                        <th colSpan="7">Total</th>
                        {
                            tempRes.map((x, i) => {
                                if (x.name === "lossGain") {
                                    return (<th key={i}></th>)
                                } else {
                                    return (<th key={i} style={{ textAlign: "right" }}>{x.value.toFixed(2)}</th>)
                                }
                            })
                        }
                    </tr>
                );
            }
        }

        return (
            <div>
                <h3><center><u>Check Roll Weighment Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Feild: </b> {searchData.feild === undefined ? "All Feilds" : searchData.feild}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="card">
                    <div class="card-header"><h6>Weigh Details</h6></div>
                    <div className="card-body">
                        <p className="d-inline pr-3"><b>Net Amount : </b> {details.gross} Kg</p>
                        <p className="d-inline pr-3"><b>Checkroll Amount : </b>{details.net} Kg</p>
                        <p className="d-inline pr-3"><b>Actual Amount : </b>{details.total} Kg</p>
                        <div className="d-inline"><b>Total {details.gainloss < 0 ? " Loss" : " Gain"} : </b><div className={details.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}
                            style={{ fontSize: "14px" }}>{Math.abs(details.gainloss)} Kg</div></div>
                        <br></br>
                        {detailDeductions.map((d, i) => {
                            return (
                                <p key={i} className="pt-3 d-inline pr-3"><b>{d.name} : </b>{roundNumbers(d.value)} Kg</p>
                            )
                        })}
                    </div>
                </div>
                {data.map((e, index) => {
                    return (
                        <div key={index} className="pl-2">
                            <div>
                                <p><b>Session start time: {e[0].sosTime}</b></p>
                                <table
                                    id={e[0].mobileSubSessionID}
                                    className="table table-bordered pb-3">
                                    <thead>
                                        <tr style={{ fontSize: "12px" }}>
                                            <th></th>
                                            <th style={{ fontSize: "12px" }}>EPF No</th>
                                            <th style={{ fontSize: "12px" }}>FirstName</th>
                                            <th style={{ fontSize: "12px" }}>Division</th>
                                            <th style={{ fontSize: "12px" }}>Field</th>
                                            <th style={{ fontSize: "12px" }}>Gang</th>
                                            <th style={{ fontSize: "12px" }}>Session</th>
                                            <th style={{ fontSize: "12px" }}>WeightRead Time</th>
                                            <th style={{ fontSize: "12px" }}>Actual Amount (Kg)</th>
                                            {headerLables.map((data, index) => {
                                                return (
                                                    <th style={{ fontSize: "12px" }} key={index}>{data}</th>
                                                );
                                            })}
                                            <th style={{ fontSize: "12px" }}>Deduction</th>
                                            <th style={{ fontSize: "12px" }}>Net Amount (Kg)</th>
                                            <th style={{ fontSize: "12px" }}>Checkroll Amount (Kg)</th>
                                            <th style={{ fontSize: "12px" }}>Extra Kg(Kg)</th>
                                            <th style={{ fontSize: "12px" }}>Gain/ Loss (Kg)</th>
                                            <th style={{ fontSize: "12px" }}>Tare Weight (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontSize: "12px" }}>
                                        <WeighReportContent
                                            data={e}
                                            contentRowNames={rowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                    <tfoot>
                                        {generateTotalRow(e[0].mobileSubSessionID)}
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}